/* =============================================================
   KLARHEIT 2027 — Auto-Gift (7-Tage-Challenge "Gratis dabei")
   When the cart contains an eligible host product (AIR / 8), the
   Challenge GIFT variant (€0 "Geschenk") is auto-added at qty 1.
   Removed when no eligible product remains. Qty capped at 1.
   The gift variant is priced €0 (no discount), so the AIR/8 multibuy
   tiers are never blocked by a BXGY prerequisite.
   Trigger = window.fetch patch on /cart/(add|change|update|clear).
   ============================================================= */
(function () {
  var GIFT_VARIANT = 53211590492426; // KLARHEIT 7 TAGE CHALLENGE — "Geschenk" (€0)
  var ELIGIBLE_HANDLES = ['klarheit-air', 'klarheit8'];
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var busy = false;
  var timer = null;

  function isGift(item) {
    if (item.variant_id === GIFT_VARIANT) return true;
    return !!(item.properties && (item.properties._gratis || item.properties['_gratis']));
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) { return r.json(); });
  }

  function renderSections(sections) {
    if (!sections) return;
    var drawerHTML = sections['cart-drawer'];
    if (drawerHTML) {
      var parsed = new DOMParser().parseFromString(drawerHTML, 'text/html');
      var fresh = parsed.querySelector('#CartDrawer');
      var current = document.querySelector('#CartDrawer');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
    var bubbleHTML = sections['cart-icon-bubble'];
    if (bubbleHTML) {
      var bubble = document.getElementById('cart-icon-bubble');
      var parsedB = new DOMParser().parseFromString(bubbleHTML, 'text/html');
      var freshB = parsedB.querySelector('.shopify-section') || parsedB.body.firstElementChild;
      if (bubble && freshB) bubble.innerHTML = freshB.innerHTML;
    }
  }

  function sync() {
    if (busy) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasEligible = false, gift = null;
        (cart.items || []).forEach(function (it) {
          if (ELIGIBLE_HANDLES.indexOf(it.handle) >= 0) hasEligible = true;
          if (isGift(it)) gift = it;
        });

        var op = null;
        if (hasEligible && !gift) {
          op = postJSON('/cart/add.js', {
            items: [{ id: GIFT_VARIANT, quantity: 1, properties: { _gratis: 'true' } }],
            sections: SECTIONS, sections_url: window.location.pathname,
          });
        } else if (!hasEligible && gift) {
          op = postJSON('/cart/change.js', {
            id: String(gift.key), quantity: 0,
            sections: SECTIONS, sections_url: window.location.pathname,
          });
        } else if (gift && gift.quantity > 1) {
          op = postJSON('/cart/change.js', {
            id: String(gift.key), quantity: 1,
            sections: SECTIONS, sections_url: window.location.pathname,
          });
        }

        if (!op) return null;
        busy = true;
        return op
          .then(function (res) { renderSections(res && res.sections); })
          .catch(function () {})
          .then(function () { busy = false; });
      })
      .catch(function () {});
  }

  function scheduleSync() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; if (!busy) sync(); }, 150);
  }

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var a = arguments;
      var url = (a[0] && a[0].url) ? a[0].url : ('' + a[0]);
      var p = origFetch.apply(this, a);
      if (!busy && CART_MUTATION.test(url)) {
        p.then(function () { scheduleSync(); }).catch(function () {});
      }
      return p;
    };
  }

  function init() { sync(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
